module.exports = __webpack_public_path__ + "img/check-green.e3ab3dd2.svg";